import { combineReducers } from '@reduxjs/toolkit'
import city from './headerSlice'

const reducer = combineReducers({
    city,
})

export default reducer
